import { Box, Button, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { UnfoldMore } from "@mui/icons-material";

export const StyledLoginButton = styled(Button)(({ theme }) => ({
  color: theme.palette.primary.main,
  borderColor: theme.palette.primary.main,
  backgroundColor: theme.palette.common.white,

  "&:hover": {
    borderColor: theme.palette.primary.dark,
    backgroundColor: theme.palette.action.hover,
  },
})) as typeof Button;

export const StyledProfileButton = styled(Button)({
  color: "#363846",
  display: "flex",
  alignItems: "center",
  minWidth: 0,
  maxWidth: "100%",
}) as typeof Button;

export const StyledWrapper = styled(Box)({
  textAlign: "left",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  justifyContent: "flex-start",
  textTransform: "none",
  minWidth: 0,
});

export const StyledProfileLogin = styled(Typography)({
  fontWeight: 700,
  fontSize: 15,
  width: "100%",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
});

export const StyledProfileRole = styled(Typography)({
  fontWeight: 500,
  fontSize: 12,
  width: "100%",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
});

export const StyledUnfoldMore = styled(UnfoldMore)(({ theme }) => ({
  margin: theme.spacing(0, 1),
  width: 24,
}));
